import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';


import { Claim} from "../../models/claim.model";
import {SelectorBase}  from "./selector-base.component";


import { Contact, ContactStub } from '../../models/contact.model';
@Component({
    selector: 'admin-user-selector',
    templateUrl: "./selector-base.component.html",
    styleUrls: ['./selector-base.component.scss'],
    standalone: false
})
export class UserSelector extends SelectorBase<Contact, ContactStub> {

    elementEqualsOutput(element: Contact, output: ContactStub): boolean {
        return element.id === output.id;
    }

    compareElements(a: Contact, b: Contact): number {
        if(a.lastName > b.lastName) return 1;
        else if (a.lastName< b.lastName) return -1;
        else{
            if(a.firstName > b.firstName) return 1;
            else if (a.firstName < b.firstName) return -1;
            return 0;
        }

    }
    elementToOutput(element: Contact): ContactStub {
        let c = new ContactStub();
        c.id = element.id;
        c.displayName = element.displayName;
        return c;
    }
    getDisplay(element: Contact): string {
        return element.displayName + "( " + element.organizationId + " )" ;
    }


}
